/* eslint-disable */

import { useNavigate, useParams } from "react-router-dom";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import { useEffect, useState } from "react";
import { fetchGraphQL } from "../../../services/api-raindrop.js";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element.js";
import WaterfallActivity from "../../../ui-components/waterfall-activity/waterfall-activity.tsx";

import RaindropMotionFadeUpGroup from "../../../ui-components/raindrop-motion-fade-up-group/raindrop-motion-fade-up-group.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import { Size } from "../../../logic/enums.ts";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import AccountAvatar from "../../../ui-components/account-avatar/account-avatar.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropTextFootnote from "../../../ui-components/raindrop-text-footnote/raindrop-text-footnote.tsx";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";

const WaterfallPostComment = ({ accountId, text, presignedUrl, username }) => {
  const navigate = useNavigate();

  return (
    <RaindropClickable
      additionalClasses="w-full"
      onClick={() => {
        navigate(`/raindrop/account/${accountId}`);
      }}
    >
      <FlexRow className="" tailwindItems="items-start" tailwindGap="gap-3">
        <div className="translate-y-2">
          <AccountAvatar
            isSmall={true}
            presignedUrl={presignedUrl}
            username={username}
          />
        </div>
        <FlexCol tailwindGap="gap-0" className="w-full">
          <FlexRow>
            <RaindropTextSubtitle>{username}</RaindropTextSubtitle>
          </FlexRow>
          <RaindropTextParagraph>{text}</RaindropTextParagraph>
        </FlexCol>
      </FlexRow>
    </RaindropClickable>
  );
};

const WaterfallPostComments = ({ comments, localComments }) => {
  return (
    <FlexCol className="h-full overflow-y-scroll py-4 flex-col-reverse">
      {comments.map((c) => (
        <WaterfallPostComment
          accountId={c.account.id}
          text={c.text}
          presignedUrl={c.account.presignedUrl}
          username={c.account.username}
        />
      ))}
      {localComments.map((c) => (
        <WaterfallPostComment
          accountId={c.account.id}
          text={c.text}
          username={c.username}
          presignedUrl={c.presignedUrl}
        />
      ))}
    </FlexCol>
  );
};

const CommentCreationPanel = ({
  waterfallPostId,
  username,
  presignedUrl,
  setLocalComments = (x) => {},
}) => {
  const [inputText, setInputText] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = () => {
    setIsLoading(true);
    fetchGraphQL(`
      mutation {
        postCommentCreate (
          text: "${inputText}",
          waterfallPostId: "${waterfallPostId}"
        ) {
          id
        }
      }
      
    `)
      .then((result) => {
        if (result.errors) {
          console.log(result.errors);
        }

        setLocalComments((prev) => {
          const newValues = [
            ...prev,
            { text: inputText, username: username, presignedUrl: presignedUrl },
          ];
          return newValues;
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInputText("");
      });
  };

  return (
    <FlexRow className="">
      <RaindropInput
        placeholder="What do you think?"
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
        maxLength={300}
      />
      <RaindropButton
        icon={"fa fa-send"}
        title="Send"
        style={ButtonStyle.Primary}
        onClick={onSubmit}
        isLoading={isLoading}
      />
    </FlexRow>
  );
};

const RaindropActivityComments = ({ userCurrent }) => {
  const { waterfallPostId } = useParams();
  const [waterfallPost, setWaterfallPost] = useState(null);
  const [localComments, setLocalComments] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchGraphQL(`
      query {
        waterfallPost(
          id: "${waterfallPostId}"
        ) {
          id
          text
          createdAt
          numberOfLikes
          hasLiked
          comments {
            id
            text
            account {
              id
              presignedUrl
              username
            }
          }
          mediaObjects {
            presignedUrl
          }
          accountObjectsLiked {
            id
            presignedUrl
            username
          }
          waterfall {
            id
            title
            summary
            organisation {
              presignedUrlLogo
            }
            account {
              id
              presignedUrl
              username
            }
          }
        }
      }
    `)
      .then((result) => {
        if (result.errors) {
          console.log(result.errors);
          return;
        }

        setWaterfallPost(result.data.waterfallPost);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [waterfallPostId]);

  if (isLoading) {
    return <RaindropLoadingElement />;
  }

  if (!waterfallPost) {
    return <RaindropPage>Something went wrong</RaindropPage>;
  }

  return (
    <RaindropPage>
      <RaindropBackButtonPanel />
      <div className="overflow-y-scroll h-full no-scrollbar w-full">
        <RaindropMotionFadeUpGroup>
          {/* <JSONBlob data={waterfallPost} /> */}
          <WaterfallActivity
            key={waterfallPost.id}
            waterfallPostId={waterfallPost.id}
            waterfallId={waterfallPost.waterfall.id}
            waterfallTitle={waterfallPost.waterfall.title}
            urlActivity={waterfallPost.mediaObjects[0].presignedUrl}
            urlOrganisation={
              waterfallPost.waterfall.organisation.presignedUrlLogo
            }
            urlUser={waterfallPost.waterfall.account.presignedUrl}
            activityDescription={waterfallPost.text}
            username={waterfallPost.waterfall.account.username}
            createdAt={waterfallPost.createdAt}
            numberOfLikes={waterfallPost.numberOfLikes}
            hasLiked={waterfallPost.hasLiked}
            accountObjectsLiked={waterfallPost.accountObjectsLiked}
            // setCurrentModalComponent={setCurrentModalComponent}
          />
          <WaterfallPostComments
            comments={waterfallPost.comments}
            localComments={localComments}
          />
        </RaindropMotionFadeUpGroup>
      </div>
      <CommentCreationPanel
        waterfallPostId={waterfallPostId}
        username={userCurrent.account.username}
        presignedUrl={userCurrent.account.presignedUrl}
        setLocalComments={setLocalComments}
      />
    </RaindropPage>
  );
};

export default RaindropActivityComments;
